import { createReducer } from '@reduxjs/toolkit';

import { setBookingFormInitialValues } from 'redux/actions/experience';

export const initialState = {
  ...window.ecom.redux_initial_state.experience,
  initialValues: {},
};

export default createReducer(initialState, {
  [setBookingFormInitialValues]: (state, action) => {
    state.initialValues = { ...state.initialValues, ...action.payload };
  },
});
